import { render, staticRenderFns } from "./Linha.vue?vue&type=template&id=1ba57c4c&scoped=true&"
var script = {}
import style0 from "./Linha.vue?vue&type=style&index=0&id=1ba57c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba57c4c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba57c4c')) {
      api.createRecord('1ba57c4c', component.options)
    } else {
      api.reload('1ba57c4c', component.options)
    }
    module.hot.accept("./Linha.vue?vue&type=template&id=1ba57c4c&scoped=true&", function () {
      api.rerender('1ba57c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/components/Linha.vue"
export default component.exports